import { useDefaultLeadViewDisplayColumnsComposable } from '@/composable/user/leadList/default-lead-view-display-columns';
import { useLeadViewCondition } from '@/composable/user/leadList/use-lead-view-condition';

export const useLeadViewState = () => {
  const {
    defaultDisplayColumns,
    fetchDisplayColumns,
    setDefaultDisplayColumns,
    hasCustomDefaultSetting,
    updateDisplayColumns,
  } = useDefaultLeadViewDisplayColumnsComposable();

  const { displayColumns, isConditionChanged } = useLeadViewCondition({
    defaultDisplayColumns,
  });

  return {
    displayColumns,
    isConditionChanged,
    fetchDisplayColumns,
    setDefaultDisplayColumns,
    hasCustomDefaultSetting,
    updateDisplayColumns,
  };
};
